import { inject, runInInjectionContext } from '@angular/core';
import { Router, Scroll } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { auditTime, filter } from 'rxjs';
import { once } from '@web/utils';
import { ScrollToAnchorAfterRedirectionOptions } from '../types/scroll-to-anchor-after-redirection-options';

export const scrollToAnchorAfterRedirection = (
  factory: () => ScrollToAnchorAfterRedirectionOptions,
  timeAfterRedirect = 0,
) => {
  const { injector, anchor, offset = [0, 0] } = factory();
  const router = runInInjectionContext(injector, () => inject(Router));
  const viewportScroller = runInInjectionContext(injector, () =>
    inject(ViewportScroller),
  );

  router.events
    .pipe(
      auditTime(timeAfterRedirect),
      filter((e) => e instanceof Scroll),
      once(),
    )
    .subscribe(() => {
      viewportScroller.setOffset(offset);
      viewportScroller.scrollToAnchor(anchor);
    });
};
